import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VRow,
        {
          class: {
            "pl-5 pt-2": _vm.$vuetify.breakpoint.mdAndUp,
            "pl-0 pt-4": _vm.$vuetify.breakpoint.smAndDown,
          },
        },
        [
          _c(
            VCol,
            { staticClass: "col-xl-9 col-12 col-sm-9 col-lg-9" },
            [
              _c("strong", [_vm._v("Módulos con acceso")]),
              _c(
                VRow,
                { staticClass: "pb-3" },
                _vm._l(_vm.onFilterMenu(), function (item) {
                  return _c(
                    VCol,
                    {
                      staticClass:
                        "mt-3 col-12 col-sm-12 col-md-6 col-xl-4 pr-0",
                    },
                    [
                      _c(
                        VCard,
                        {
                          style: {
                            backgroundColor: _vm.checkRoles(item.roles_user)
                              ? "white"
                              : "#F5F5F5",
                          },
                          attrs: {
                            "max-height": "140px",
                            "min-height": "140px",
                            disabled: !_vm.checkRoles(item.roles_user),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.go_to(item)
                            },
                          },
                        },
                        [
                          _c(
                            VCardTitle,
                            {
                              class: {
                                "pb-0": _vm.$vuetify.breakpoint.mdAndUp,
                                "pb-0 pr-0": _vm.$vuetify.breakpoint.smAndDown,
                              },
                            },
                            [
                              _vm.checkRoles(item.roles_user)
                                ? _c(
                                    VIcon,
                                    {
                                      style: {
                                        backgroundColor: item.color_icon,
                                        padding: "7px",
                                        borderRadius: "20%",
                                        fontSize: "15px",
                                      },
                                      attrs: { color: "white" },
                                    },
                                    [_vm._v(_vm._s(item.icon))]
                                  )
                                : _vm._e(),
                              !_vm.checkRoles(item.roles_user)
                                ? _c(
                                    VIcon,
                                    {
                                      style: {
                                        backgroundColor: "#949494",
                                        padding: "3px",
                                        borderRadius: "20%",
                                      },
                                      attrs: { color: "#f5f5f5" },
                                    },
                                    [_vm._v(_vm._s(item.icon))]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass: "ml-1",
                                  staticStyle: {
                                    display: "flex !important",
                                    "align-items": "center !important",
                                    "justify-content": "center !important",
                                  },
                                },
                                [_vm._v(" " + _vm._s(item.name_i18n))]
                              ),
                            ],
                            1
                          ),
                          _c(VRow, { attrs: { justify: "center" } }),
                          _vm.checkRoles(item.roles_user)
                            ? _c(VCardText, { staticClass: "pb-1" }, [
                                _vm._v(
                                  "Roles: " +
                                    _vm._s(_vm.getString(item.roles_user))
                                ),
                              ])
                            : _c(VCardText, { staticClass: "pb-0" }, [
                                _vm._v("Módulo no disponible"),
                              ]),
                          _c(
                            "div",
                            {
                              staticStyle: { overflow: "auto" },
                              attrs: { "max-height": "50px" },
                            },
                            [
                              _c(
                                VCardActions,
                                [
                                  _c(VSpacer),
                                  _vm.checkRoles(item.roles_user)
                                    ? _c(
                                        VIcon,
                                        { attrs: { color: "green" } },
                                        [_vm._v("icon-unlocked")]
                                      )
                                    : _c(
                                        VIcon,
                                        { attrs: { color: "#949494" } },
                                        [_vm._v("icon-locked")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
              _c("p", { staticClass: "mb-0 pt-4" }, [
                _c("strong", [_vm._v("Métricas")]),
              ]),
              _c(
                VRow,
                { staticClass: "pt-0" },
                [
                  _c(
                    VCol,
                    {
                      staticClass:
                        "mt-3 col-12 col-sm-12 col-md-12 col-xl-12 pr-0",
                    },
                    [_c("inca-metrics")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VCol,
            { staticClass: "col-xl-3 col-12 col-sm-12 col-lg-3" },
            [
              _c("strong", [_vm._v("Mis metricas")]),
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    {
                      staticClass:
                        "mt-0 col-12 col-sm-12 col-md-12 col-xl-12 pr-5",
                    },
                    [_c("my-inca-metrics")],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "pt-3" },
                [
                  _c(
                    VCol,
                    {
                      staticClass:
                        "mt-3 col-12 col-sm-12 col-md-12 col-xl-12 pr-5",
                    },
                    [
                      _c(
                        VCard,
                        {
                          style: {
                            position: "relative",
                            backgroundColor: _vm.color,
                          },
                          attrs: { "min-height": "140px" },
                        },
                        [
                          _c(VCardText, { staticClass: "pr-0" }, [
                            _c(
                              "div",
                              {
                                style: {
                                  position: "absolute",
                                  top: "35%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                },
                              },
                              [
                                _c(
                                  VRow,
                                  {
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "text-center",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(VImg, {
                                          staticStyle: { margin: "0 auto" },
                                          attrs: {
                                            src: require("@/assets/ui-ia.png"),
                                            width: "40%",
                                            contain: "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      {
                                        staticClass: "mb-1 text-center",
                                        style: {
                                          color: "#81BEF7",
                                          fontSize: "1em",
                                          lineHeight: "1em",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Nuevo Generador de imágenes con Inteligencia Artificial"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VRow,
                                  [
                                    _c(
                                      VCol,
                                      { staticClass: "text-center" },
                                      [
                                        _c(
                                          VBtn,
                                          {
                                            staticClass: "mb-2",
                                            style: { color: "white" },
                                            attrs: { color: "#0043ed" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$router.push(
                                                  "/AiTools/GenerativeImage"
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Explorar herramienta")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("p", { staticClass: "pt-13" }, [_vm._v("Centro de Ayuda")]),
              _c(
                VRow,
                { staticClass: "pt-1" },
                [
                  _c(
                    VCol,
                    {
                      class: {
                        "pr-6": _vm.$vuetify.breakpoint.mdAndUp,
                        "pr-2": _vm.$vuetify.breakpoint.smAndDown,
                      },
                    },
                    [
                      _c(
                        VCard,
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/help_center/elements/2")
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pr-0" },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          style: {
                                            backgroundColor: "#6200EA",
                                            padding: "7px",
                                            borderRadius: "20%",
                                          },
                                          attrs: { color: "white" },
                                        },
                                        [_vm._v("icon-videos")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VCol, { attrs: { cols: "10" } }, [
                                    _vm._v("Videos tutoriales"),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: { "font-size": "13px" },
                                      },
                                      [_vm._v("Conoce cómo usar INCA Platform")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "pt-3" },
                [
                  _c(
                    VCol,
                    {
                      class: {
                        "pr-6": _vm.$vuetify.breakpoint.mdAndUp,
                        "pr-2": _vm.$vuetify.breakpoint.smAndDown,
                      },
                    },
                    [
                      _c(
                        VCard,
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/help_center/elements/1")
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pr-0" },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          style: {
                                            backgroundColor: "red",
                                            padding: "7px",
                                            borderRadius: "20%",
                                          },
                                          attrs: { color: "white" },
                                        },
                                        [_vm._v("icon-read_learn")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VCol, { attrs: { cols: "10" } }, [
                                    _vm._v("Aprende"),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: { "font-size": "13px" },
                                      },
                                      [
                                        _vm._v(
                                          "Conoce más sobre los módulos y roles"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { staticClass: "pt-3" },
                [
                  _c(
                    VCol,
                    {
                      class: {
                        "pr-6": _vm.$vuetify.breakpoint.mdAndUp,
                        "pr-2": _vm.$vuetify.breakpoint.smAndDown,
                      },
                    },
                    [
                      _c(
                        VCard,
                        {
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/help_center/elements/3")
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pr-0" },
                            [
                              _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    { attrs: { cols: "2" } },
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          style: {
                                            backgroundColor: "#48CBFF",
                                            padding: "7px",
                                            borderRadius: "20%",
                                          },
                                          attrs: { color: "white" },
                                        },
                                        [_vm._v("icon-feedback")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(VCol, { attrs: { cols: "10" } }, [
                                    _vm._v("Feedback"),
                                    _c(
                                      "p",
                                      {
                                        staticClass: "mb-0",
                                        staticStyle: { "font-size": "13px" },
                                      },
                                      [
                                        _vm._v(
                                          "Tu opinión es importante para mejorar"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("hub-ia-migration-dialog", { ref: "hub_ia_dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }